import { useCallback } from 'react';

import { useAppDispatch } from 'features/app/hooks';
import {
  type InteractionSource,
  interactionAnalytics,
} from 'features/analytics/helpers';

interface UseTrackedInteractionActionParams {
  actionName: string;
  methodName: string;
  eventName?: string;
}

export const useTrackedInteractionAction = ({
  actionName,
  methodName,
  eventName = 'Interaction',
}: UseTrackedInteractionActionParams) => {
  const dispatch = useAppDispatch();

  const track = useCallback(
    (source: InteractionSource) => {
      dispatch(
        interactionAnalytics({
          actionName,
          methodName,
          eventName,
          source,
        })
      );
    },
    [actionName, dispatch, eventName, methodName]
  );

  const onActionClick = useCallback(() => {
    track('click');
  }, [track]);

  const onActionHotkey = useCallback(() => {
    track('hotkey');
  }, [track]);

  return {
    onActionClick,
    onActionHotkey,
  };
};
